var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerSpin360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver_spin360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.005,
    height: 44.805,
    viewBox: "0 0 48.005 44.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #003169;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    width: 48.005,
    height: 44.805
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-1",
    d: "M660.542,396.8v-6.4a1.971,1.971,0,0,0-.018-.26c0-.029-.011-.057-.016-.085a1.643,1.643,0,0,0-.036-.166c0-.017-.01-.034-.016-.052L648,396.763v14.616l11.475-5.74a1.929,1.929,0,0,0,1.067-1.726v-2.877c3.655,1.833,5.788,4.3,5.788,6.794,0,3.148-3.392,6.234-8.852,8.056l1.22,3.661c7.2-2.4,11.491-6.779,11.491-11.717,0-4.493-3.516-8.5-9.647-11.027Zm0,0",
    transform: "translate(-623.223 -382.235)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-1",
    d: "M468.659,412.255l-2.729,2.729,2.385,2.385c-9.172-.71-16.456-4.789-16.456-9.537,0-2.5,2.13-4.962,5.788-6.792v2.875a1.929,1.929,0,0,0,1.067,1.726l11.475,5.737V396.763l-12.454-6.919c-.006.017-.012.034-.016.052-.015.054-.026.11-.036.166-.005.028-.013.056-.016.085a2.035,2.035,0,0,0-.019.26v6.4C451.6,399.3,448,403.389,448,407.831c0,7.089,8.909,12.738,20.694,13.433l-2.451,2.612,2.814,2.641,5.432-5.788a1.93,1.93,0,0,0-.043-2.685Zm0,0",
    transform: "translate(-447.341 -382.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-1",
    d: "M564.708,336.266l-11.1-5.551a1.931,1.931,0,0,0-1.726,0l-11.1,5.551,11.965,6.648Zm0,0",
    transform: "translate(-528.93 -330.058)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerSpin360);
export default __webpack_public_path__ + "static/media/ver_spin360.603b75f1424d71c09b5bfc4931d17f81.svg";
export { ForwardRef as ReactComponent };